import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2523812c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "weight",
  class: "section-weight"
}
const _hoisted_2 = { class: "section-inner" }
const _hoisted_3 = { class: "video-wrap gif-container" }
const _hoisted_4 = { class: "html-embed w-embed" }
const _hoisted_5 = { class: "video-mask" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = {
  class: "ai-review-card",
  dir: "auto"
}
const _hoisted_8 = { class: "ai-review-card__topline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Text = _resolveComponent("Text")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Text, {
        class: "section-copy",
        eyebrow: _ctx.$t('home.weight.eyebrow'),
        header: _ctx.formattedHeader,
        content: _ctx.formattedDesc,
        linkcont: _ctx.$t('home.weight.button'),
        link: "info",
        textAlign: "end"
      }, null, 8, ["eyebrow", "header", "content", "linkcont"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _ctx.demo,
              alt: _ctx.$t('home.weight.imageAlt'),
              class: "demo-image"
            }, null, 8, _hoisted_6)
          ])
        ]),
        _createElementVNode("aside", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('home.weight.reviewCard.label')), 1),
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('home.weight.reviewCard.metric')), 1)
          ]),
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('home.weight.reviewCard.title')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('home.weight.reviewCard.body')), 1)
        ])
      ])
    ])
  ]))
}